const {
  NotificationPanel,
} = require("src/client-ts/components/NotificationPanel");

exports.notificationPanel = NotificationPanel;
